import { useEffect, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { LanguageBanner } from "@/components/layout/LanguageBanner";
import { StickyBookCTA } from "@/components/layout/StickyBookCTA";
import { CookieBanner } from "@/components/layout/CookieBanner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
  }, []);
  useLayoutEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    // `behavior: instant` overrides the global `scroll-behavior: smooth`.
    // We re-assert on the next frame + macrotask to override Chromium's
    // scroll-anchoring, which otherwise re-scrolls as new content mounts.
    const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    toTop();
    const raf = requestAnimationFrame(toTop);
    const timer = setTimeout(toTop, 0);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [pathname, hash]);
  return null;
}

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <ScrollToTop />
      <LanguageBanner />
      <Navbar />
      <main className="min-w-0 flex-1 overflow-x-clip">
        <Outlet />
      </main>
      <Footer />
      <StickyBookCTA />
      <CookieBanner />
    </div>
  );
}
